import React from 'react';
import logo3F from '../assets/logo3F.jpg';

export default function Header({ config, onOuvrirConfig, onVider }) {
  const connecte = !!config.url;

  return (
    <div style={styles.header}>
      <div style={styles.gauche}>
        <img src={logo3F} alt="3F" style={styles.avatarImg} />
        <div>
          <div style={styles.nom}>Les Usagers de 3F Yvelines</div>
          <div style={styles.statut}>
            <span style={{ ...styles.dot, background: connecte ? '#4ade80' : '#f87171' }} />
            <span>{connecte ? 'En ligne' : 'Non configuré'}</span>
          </div>
        </div>
      </div>
      <div style={styles.actions}>
        <button style={styles.iconBtn} onClick={onVider} title="Vider la conversation">🗑</button>
        <button style={styles.iconBtn} onClick={onOuvrirConfig} title="Paramètres">⚙️</button>
      </div>
    </div>
  );
}

const styles = {
  header: {
    background: '#1a3a5c',
    padding: '0 1rem',
    height: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  gauche: { display: 'flex', alignItems: 'center', gap: '.85rem' },
  avatarImg: {
    width: 42, height: 42,
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid rgba(255,255,255,.25)',
    flexShrink: 0,
  },
  nom: { fontSize: '.95rem', fontWeight: 600, color: '#fff' },
  statut: { fontSize: '.72rem', color: 'rgba(255,255,255,.65)', display: 'flex', alignItems: 'center', gap: '.35rem', marginTop: 1 },
  dot: { width: 6, height: 6, borderRadius: '50%', flexShrink: 0 },
  actions: { display: 'flex', gap: '.4rem' },
  iconBtn: {
    width: 34, height: 34, borderRadius: '50%',
    background: 'transparent', border: 'none', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '1.1rem', color: 'rgba(255,255,255,.8)',
  },
};
